export const otpFieldContainerStyles = `flex flex-col items-center w-full`

export const otpBoxesFieldContainerStyles = `self-start w-full`

export const resendOTPWithTimerContainerStyles = `flex justify-between w-full`

export const resendOTPWithOTPTimerContainerStyles = `flex justify-between w-full items-center mt-2`

export const otpTimerTextStyles = `text-sm-semibold select-none text-right`

export const resendButtonStyles = `flex items-center bg-transparent right-0 outline-none`

export const resendOTPAndCallContainerStyles = `flex flex-col items-center`

export const resendOTPTextContainerStyles = `flex`

export const resendOtpTextStyles = `pointer-events-none text-sm-semibold pl-auto mr-[5px]`

export const orTextStyles = `text-xs-regular mt-1 mb-1`

export const otpErrorMessageStyles = `mb-6 my-2`

export const otpInputStyles = `!w-[44px] h-[44px] border-[1px] shadow-[0_1px_2px_rgba(0,0,0,0.08)] text-sm-medium rounded-xl last-child:!mr-0`

export const otpInputFocusStyles = `opacity-90 focus:!border-[2px] focus:outline-0 focus:outline-offset-0 focus:shadow-[0_0_0_4px_#d1e9ff] focus:shadow-[0_1px_2px_rgba(16, 24, 40,0.05)]`

export const otpErrorStyles = `border-2 focus:border-[2px]`

export const loaderStyles = `mx-3.5 self-center`
